$(async function ($) {
    $(document).on('click', '.cart__item-remove', function (e) {
        e.preventDefault();

        const el = $(this)
        const product = el.closest('[data-product-item]')
        const removeBtns = $('[data-product-remove]')
        const counterBtns = $('[data-product-counter]')
        const total = $('[data-total]')
        const btn = $('[data-checkout-btn]')
        const product_key = $(this).closest('.cart__item').data('key');

        product.addClass('item--loading')
        total.addClass('item--loading')
        btn.addClass('disabled')
        removeBtns.addClass('disabled')
        counterBtns.addClass('disabled')

        try {
            $.ajax({
                type: 'POST',
                url: '/wp-admin/admin-ajax.php',
                data: {
                    action: 'remove_from_cart_and_get_total',
                    product_key: product_key
                },
                success: function (response) {
                    if (!response || response.error)
                        return;
                    let result = JSON.parse(response)
                    product.remove()
                    total.removeClass('item--loading')
                    btn.removeClass('disabled')
                    removeBtns.removeClass('disabled')
                    counterBtns.removeClass('disabled')

                    if (result.cart_count)
                        $('[data-header-cart-quantity]').show().html(`<span>${result.cart_count}</span>`)

                    if (!result.cart_count)
                        window.location.reload()

                    if (result.cart_total)
                        $('[data-total-value]').html(result.cart_total)
                }
            });
        } catch (e) {
            product.removeClass('item--loading')
            total.removeClass('item--loading')
            btn.removeClass('disabled')
            removeBtns.addClass('disabled')
            counterBtns.addClass('disabled')
        }

    });
});
